import React from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import moment from 'moment';
import _ from 'lodash';
import { formatWorkDuration } from '../../../../util/dates';

import '../../Reports.scss';
import pagination from '../../../../util/pagination';
import chartUtils from '../../../../util/chartUtils';
class ReportTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getColumnName(dates) {
    return dates.type === 'quarter'
      ? `${moment.utc(dates.from).format(this.props.dateFormat)} - ${moment.utc(dates.to).format(this.props.dateFormat)}`
      : `${moment(dates.from).format(this.props.dateFormat)} - ${moment(dates.to).format(this.props.dateFormat)}`;
  }

  handleChange = e => {
    this.props.changePercentile(e.value);
  };

  renderPercentilesDropDown() {
    const { percentile } = this.props;
    return (
      <DropdownButton
        key="1"
        id="createdashboards-dropdown"
        className='form-control-dropdown comparison-percentile'
        title={`${percentile}th percentile`}
      >
        {[30, 50, 70, 85, 95, 98].map(p => (
          <Dropdown.Item
            key={p}
            as="button"
            className={percentile == p ? 'active' : ''}
            onClick={() => this.handleChange({ value: p })}
          >
            {`${p}th percentile`}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    );
  }

  renderValue(value, positive = false, time = false) {
    if (value && value.value) {
      const displayValue = time
        ? formatWorkDuration(value.value, this.props.excludeWeekendOpts, 'd[d] h[h]')
        : value.value.toFixed(2);
      if (typeof value.comparison === 'undefined') {
        return <span className='comparison-value'>{displayValue}</span>;
      }
      const rising = value.comparison > 0;
      const tone = value.active ? (rising !== positive ? 'positive' : 'negative') : 'neutral';
      return (
        <span className='comparison-cell'>
          <span className={`comparison-delta value ${tone}`}>
            <span className={tone}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                {value.active ? (rising ? (
                  <React.Fragment><path d="M12 19V5" /><path d="m5 12 7-7 7 7" /></React.Fragment>
                ) : (
                  <React.Fragment><path d="M12 5v14" /><path d="m19 12-7 7-7-7" /></React.Fragment>
                )) : (
                  <React.Fragment><path d="M5 9h14" /><path d="M5 15h14" /></React.Fragment>
                )}
              </svg>
            </span>
            {value.comparison.toFixed()}%
          </span>
          <span className='comparison-value'>{displayValue}</span>
        </span>
      );
    } else {
      return <span className='comparison-value'>-</span>;
    }
  }

  renderPagination = () => {
    const pages = pagination(this.props.total, this.props.page, 10, 5);

    if (pages.totalPages < 2) {
      return <div></div>;
    }

    return (
      <ul className="pagination">
        {pages.currentPage > 1 && (
          <li aria-label="First" onClick={() => this.goto(1)}>
            <a role="button" href="#">
              «
            </a>
          </li>
        )}
        {pages.currentPage > 1 && (
          <li aria-label="Prev" onClick={() => this.goto(pages.currentPage - 1)}>
            <a role="button" href="#">
              ‹
            </a>
          </li>
        )}
        {pages.pages.map((p, i) => {
          return (
            <li className={p === pages.currentPage ? 'active' : ''} key={i} onClick={() => this.goto(p)}>
              <a role="button" href="#">
                {p}
              </a>
            </li>
          );
        })}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Next" onClick={() => this.goto(pages.currentPage + 1)}>
            <a role="button" href="#">
              ›
            </a>
          </li>
        )}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Last" onClick={() => this.goto(pages.totalPages)}>
            <a role="button" href="#">
              »
            </a>
          </li>
        )}
      </ul>
    );
  };

  isEmpty() {
    const { data, fieldName } = this.props;
    return !_.some(_.flatMap(data), (group) => _.some(group?.[fieldName], (v) => _.isFinite(v?.value)));
  }

  render() {
    const empty = !this.props.loading && this.isEmpty();
    return (
      <React.Fragment>
        <div className='table-content table-content-no-resp table-card'>
          {(this.props.loading || empty) && (
            <div className='table-filter'>
              <h5>{this.props.columnHeader}</h5>
            </div>
          )}

          {(this.props.loading || empty) && (
            <div
              className={`chart-placeholder chart-placeholder--table ${this.props.loading ? 'chart-placeholder--loading' : ''}`}
              dangerouslySetInnerHTML={{ __html: chartUtils.placeholderMarkup('table', this.props.loading) }}
            />
          )}
          {!this.props.loading && !empty && (
            <div className='table-scroll'>
              <table className='table'>
                <thead>
                  <tr>
                    <th className='comparison-name'>
                      <h5>{this.props.columnHeader}</h5>
                      {this.props.percentile && this.renderPercentilesDropDown()}
                    </th>
                    {/* each period's name over its dates; the period assessed first (3190 EX 5) */}
                    {this.props.dates.map((d, i) => (
                      <th className='aling-right'  key={i}>
                        {this.props.columnLabels && <p className='comparison-period'>{this.props.columnLabels[i]}</p>}
                        <p className={this.props.columnLabels ? 'comparison-dates' : ''}>{this.getColumnName(d)}</p>
                      </th>
                    ))}
                  </tr>
                </thead>
                
                <tbody>
                  {_.map(this.props.data, (r, i) => {
                    return (
                      <React.Fragment key={i}>
                        {
                          r.map((g, i) => {
                            return (
                              <tr key={i}>
                                <td>
                                  <p>{g.name}</p>
                                </td>
                                <td className='aling-right'>
                                  <p>{this.renderValue(g[this.props.fieldName][0], this.props.positive, this.props.time)}</p>
                                </td>
                                <td className='aling-right'>
                                  <p>{this.renderValue(g[this.props.fieldName][1], this.props.positive, this.props.time)}</p>
                                </td>
                                <td className='aling-right'>
                                  <p>{this.renderValue(g[this.props.fieldName][2], this.props.positive, this.props.time)}</p>
                                </td>
                                <td className='aling-right'>
                                  <p>{this.renderValue(g[this.props.fieldName][3], this.props.positive, this.props.time)}</p>
                                </td>
                              </tr>
                            );
                          })
                        }
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {this.props.total > 0 && this.renderPagination()}
        </div>

        {this.props.loading && (
          <div className='table-loading loader-delay'>
            <Loading />
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default ReportTable;
